<template>
  <el-dialog width="500px" title="Alipay Config" :close-on-click-modal="false" :visible.sync="visible" top="6vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="94px" v-loading="loading">
      <el-form-item label="QR Code" prop="alipayQrcodeUrl">
        <el-image-uploader v-model="dataForm.alipayQrcodeUrl"></el-image-uploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        alipayQrcodeUrl: {
          name: "",
          url: "",
        },
      },
      dataRule: {
        alipayQrcodeUrl: [
          {
            type: "object",
            required: true,
            fields: {
              url: { required: true, message: "please upload", trigger: "submit" },
            },
          },
        ],
      },
      loading: false,
      submitLoading: false,
    };
  },
  methods: {
    async init() {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      this.getDetail();
    },
    //详情
    async getDetail() {
      this.loading = true;
      this.$http
        .get("/admin/stCustomPageManage/detail")
        .then(res => {
          const resData = res.data || {};
          const { alipayQrcodeUrl } = resData;
          this.dataForm = {
            alipayQrcodeUrl,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post("/admin/stCustomPageManage/update", this.dataForm)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
